// @flow
import type { PendingReservation } from "./types"

export const addToBasket = (
  (reservation: PendingReservation) => (
    { type: "BASKET/ADD_TO_BASKET", payload: { reservation } }
  )
);

export const clearBasket = () => ({
  type: "BASKET/CLEAR_BASKET",
})



// WEBPACK FOOTER //
// ./src/data/basket/actions.js